import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buydata',
  templateUrl: './buydata.component.html',
  styleUrls: ['./buydata.component.css']
})
export class BuydataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
